/* eslint-disable camelcase */
/* eslint-disable react/jsx-no-bind */
import React from 'react';
import PropTypes from 'prop-types';
import { Menu, Dropdown, Button } from 'antd';

const LanguageSwitcher = ({ translations }) => {
  const languages = Object.keys(translations).map((code) => translations[code]);
  const currentLanguage = languages.find(({ current_lang }) => !!current_lang);

  function handleMenuClick({ key }) {
    const { url } = translations[key];
    window.location.href = `${url}`; // eslint-disable-line no-undef
  }

  const menu = (
    <Menu onClick={handleMenuClick} selectedKeys={[currentLanguage.name]}>
      {languages.map((language) => (
        <Menu.Item key={language.name}>{language.name.toUpperCase()}</Menu.Item>
      ))}
    </Menu>
  );

  return (
    <Dropdown key="lang" overlay={menu}>
      <Button size="small">{currentLanguage.name.toUpperCase()}</Button>
    </Dropdown>
  );
};

LanguageSwitcher.propTypes = {
  translations: PropTypes.shape({
    name: PropTypes.string,
    url: PropTypes.string,
    current_lang: PropTypes.bool,
  }).isRequired,
};

export default LanguageSwitcher;
